/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sch_Err_HierarchyInputs */

const en_sch_err_hierarchy = /** @type {(inputs: Sch_Err_HierarchyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} parent and child pairs would break, so nothing was changed.`)
};

const de_sch_err_hierarchy = /** @type {(inputs: Sch_Err_HierarchyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Paare aus übergeordnetem und untergeordnetem Vorgang würden brechen, deshalb wurde nichts geändert.`)
};

/**
* | output |
* | --- |
* | "{count} parent and child pairs would break, so nothing was changed." |
*
* @param {Sch_Err_HierarchyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_hierarchy = /** @type {((inputs: Sch_Err_HierarchyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_HierarchyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_hierarchy(inputs)
	return en_sch_err_hierarchy(inputs)
});